/* eslint-disable react/prop-types */
import React, { createContext, useContext, useState, useEffect } from 'react';
import SecureStorage from 'react-secure-storage'; // Adjust the import path as needed
import Modal from 'components/modal/Modal';
import Register from 'components/authentication/register';
import { useNavigate } from 'react-router-dom';
import ROUTES_ENUMS from 'routes/url.enum';

const AuthContext = createContext();

export const useAuthContext = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [isRegisterOpen, setIsRegisterOpen] = useState(false);

  useEffect(() => {
    handleFetchData();
  }, []);

  const handleFetchData = () => {
    const storedUser = SecureStorage.getItem('customer');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      setUser(null);
    }
  };

  const handleLogout = () => {
    SecureStorage.clear();
    handleFetchData();
    navigate(ROUTES_ENUMS.HOME);
  };

  const toggleRegister = () => {
    setIsRegisterOpen(!isRegisterOpen);
  };

  const checkBangloreUser = () => {
    return user.city === 'Bengaluru';
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        isLoggedIn: !!user,
        toggleRegister,
        handleLogout,
        checkBangloreUser,
        handleFetchData
      }}
    >
      {children}
      <Modal isOpen={isRegisterOpen} onClose={toggleRegister}>
        <Register
          onClose={toggleRegister}
          handleFetchData={handleFetchData}
        />
      </Modal>
    </AuthContext.Provider>
  );
};
